import { GIF_DEFAULT_RATING, GIF_PREFIX } from './constants';
/**
 * Gets the URL of the GIF for the given participant or null if there's none.
 *
 * @param {IReduxState} state - Redux state.
 * @param {string} participantId - Id of the participant for which to remove the GIF.
 * @returns {Object}
 */
export function getGifForParticipant(state, participantId) {
    return isGifEnabled(state) ? state['features/gifs'].gifList.get(participantId) || {} : {};
}
/**
 * Whether or not the message is a GIF message.
 *
 * @param {string} message - Message to check.
 * @returns {boolean}
 */
export function isGifMessage(message) {
    return message.trim().toLowerCase()
        .startsWith(GIF_PREFIX);
}
/**
 * Returns the url of the gif selected in the gifs menu.
 *
 * @param {Object} gif - The gif data.
 * @returns {boolean}
 */
export function getGifUrl(gif) {
    var _a;
    const embedUrl = (gif === null || gif === void 0 ? void 0 : gif.embed_url) || ((_a = gif === null || gif === void 0 ? void 0 : gif.data) === null || _a === void 0 ? void 0 : _a.embed_url) || '';
    const idx = embedUrl.lastIndexOf('/');
    const id = embedUrl.substr(idx + 1);
    return `https://i.giphy.com/media/${id}/giphy.gif`;
}
/**
 * Formats the gif message.
 *
 * @param {string} url - GIF url.
 * @returns {string}
 */
export function formatGifUrlMessage(url) {
    return `${GIF_PREFIX}${url}]`;
}
/**
 * Get the Giphy API Key from config.
 *
 * @param {IReduxState} state - Redux state.
 * @returns {string}
 */
export function getGifAPIKey(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state['features/base/config']) === null || _a === void 0 ? void 0 : _a.giphy) === null || _b === void 0 ? void 0 : _b.sdkKey) !== null && _c !== void 0 ? _c : '';
}
/**
 * Returns whether or not the feature is enabled.
 *
 * @param {IReduxState} state - Redux state.
 * @returns {boolean}
 */
export function isGifEnabled(state) {
    const { disableThirdPartyRequests } = state['features/base/config'];
    const { giphy } = state['features/base/config'];
    if (navigator.product === 'ReactNative' && window.JITSI_MEET_LITE_SDK) {
        return false;
    }
    return Boolean(!disableThirdPartyRequests && (giphy === null || giphy === void 0 ? void 0 : giphy.enabled) && Boolean(giphy === null || giphy === void 0 ? void 0 : giphy.sdkKey));
}
/**
 * Get the GIF display mode.
 *
 * @param {IReduxState} state - Redux state.
 * @returns {string}
 */
export function getGifDisplayMode(state) {
    const { giphy } = state['features/base/config'];
    return (giphy === null || giphy === void 0 ? void 0 : giphy.displayMode) || 'all';
}
/**
 * Get the GIF audience rating.
 *
 * @param {IReduxState} state - Redux state.
 * @returns {string}
 */
export function getGifRating(state) {
    const { giphy } = state['features/base/config'];
    return (giphy === null || giphy === void 0 ? void 0 : giphy.rating) || GIF_DEFAULT_RATING;
}
